import { RootPaths } from "@src/appV2/App/paths";

import { AUTH_LOGIN_PATH, AUTH_SIGN_UP_PATH } from "../../../paths";

const LOGIN_PATHS = [
  RootPaths.WELCOME,
  RootPaths.AUTH_REDIRECT,
  AUTH_LOGIN_PATH,
  AUTH_SIGN_UP_PATH,
  `/${AUTH_LOGIN_PATH}`,
  `/${AUTH_SIGN_UP_PATH}`,
  `${RootPaths.APP_V2}/${AUTH_LOGIN_PATH}`,
  `${RootPaths.APP_V2}/${AUTH_SIGN_UP_PATH}`,
];

export function isLoginPath(path: string | undefined): boolean {
  if (!path) {
    return false;
  }

  // Decode URI in case it's encoded
  const decodedPath = decodeURIComponent(path);

  // Extract pathname if it's a full URL
  let pathname: string;
  try {
    ({ pathname } = new URL(decodedPath, globalThis.location.origin));
  } catch {
    pathname = decodedPath;
  }

  return LOGIN_PATHS.some(
    (loginPath) => pathname === loginPath || pathname.startsWith(`${loginPath}?`)
  );
}
